(function termsConditions() {
  // ─── BUY NOW MODAL ───────────────────────────────────────────────────────

  let pendingBuyNowBtn = null;
  let buyNowAccepted = false;

  function getModalCheckbox() {
    return /** @type {HTMLInputElement | null} */ (document.getElementById('terms-modal-checkbox'));
  }

  function getModalError() {
    return document.getElementById('terms-modal-error');
  }

  function openModal() {
    const overlay = document.getElementById('terms-modal-overlay');
    if (!overlay) return;

    // Reset checkbox and error each time the modal opens
    const cb = getModalCheckbox();
    if (cb) cb.checked = false;
    const err = getModalError();
    if (err) err.style.display = 'none';

    overlay.style.display = 'flex';
    document.body.style.overflow = 'hidden';
    cb?.focus();
  }

  function closeModal() {
    const overlay = document.getElementById('terms-modal-overlay');
    if (!overlay) return;
    overlay.style.display = 'none';
    document.body.style.overflow = '';
  }

  // Intercept all Buy Now button clicks before Shopify handles them
  document.addEventListener(
    'click',
    function (e) {
      const btn = e.target.closest('.shopify-payment-button__button');
      if (!btn || btn.disabled) return;

      // If user already accepted, let this click through and reset the flag
      if (buyNowAccepted) {
        buyNowAccepted = false;
        return;
      }

      // Only intercept if the modal exists (terms enabled)
      if (!document.getElementById('terms-modal-overlay')) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      pendingBuyNowBtn = btn;
      openModal();
    },
    true // capture phase
  );

  function initModal() {
    const overlay = document.getElementById('terms-modal-overlay');
    if (!overlay) return;

    // Close on backdrop click
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closeModal();
    });

    document.getElementById('terms-modal-close')?.addEventListener('click', closeModal);
    document.getElementById('terms-modal-cancel')?.addEventListener('click', closeModal);

    document.getElementById('terms-modal-accept')?.addEventListener('click', function () {
      const cb = getModalCheckbox();
      const err = getModalError();

      if (cb && !cb.checked) {
        if (err) err.style.display = 'block';
        cb.focus();
        return;
      }

      const btn = pendingBuyNowBtn;
      pendingBuyNowBtn = null;
      closeModal();
      if (btn) {
        buyNowAccepted = true;
        btn.click();
      }
    });

    // Hide modal error when checkbox is ticked
    document.getElementById('terms-modal-checkbox')?.addEventListener('change', function () {
      if (this.checked) {
        const err = getModalError();
        if (err) err.style.display = 'none';
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeModal();
    });
  }

  // ─── CART DRAWER CHECKOUT INTERCEPTION ──────────────────────────────────

  function getCheckbox() {
    return /** @type {HTMLInputElement | null} */ (document.getElementById('terms-checkbox'));
  }

  function getError() {
    return document.getElementById('terms-checkbox-error');
  }

  function showError() {
    const err = getError();
    if (err) err.style.display = 'block';
  }

  function hideError() {
    const err = getError();
    if (err) err.style.display = 'none';
  }

  function resetCheckbox() {
    const cb = getCheckbox();
    if (cb) cb.checked = false;
    hideError();
  }

  // Intercept the checkout button click (delegated, capture phase)
  document.addEventListener(
    'click',
    function (e) {
      const btn = e.target.closest('#checkout, button[name="checkout"]');
      if (!btn) return;

      const cb = getCheckbox();
      if (!cb) return; // terms disabled

      if (!cb.checked) {
        e.preventDefault();
        e.stopImmediatePropagation();
        showError();
        const wrapper = document.getElementById('terms-checkbox-wrapper');
        wrapper?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        cb.focus();
      }
    },
    true
  );

  // Also intercept cart form submit (e.g., triggered programmatically)
  document.addEventListener(
    'submit',
    function (e) {
      if (e.target.id !== 'cart-form') return;

      // Only block when heading to checkout (submitter name="checkout")
      const submitter = e.submitter;
      if (submitter && submitter.name !== 'checkout') return;

      const cb = getCheckbox();
      if (!cb) return;

      if (!cb.checked) {
        e.preventDefault();
        e.stopImmediatePropagation();
        showError();
        cb.focus();
      }
    },
    true
  );

  // Hide error when checkbox is ticked
  document.addEventListener('change', function (e) {
    if (e.target instanceof HTMLInputElement && e.target.id === 'terms-checkbox') {
      if (e.target.checked) hideError();
    }
  });

  // Reset checkbox state each time the cart drawer closes
  function observeCartDrawer() {
    const drawer = document.querySelector('cart-drawer-component');
    if (!drawer) return;

    const dialog = drawer.querySelector('dialog');
    if (!dialog) return;

    new MutationObserver(function (mutations) {
      for (const m of mutations) {
        if (m.attributeName === 'open' && !dialog.open) {
          resetCheckbox();
        }
      }
    }).observe(dialog, { attributes: true, attributeFilter: ['open'] });
  }

  // ─── INIT ────────────────────────────────────────────────────────────────

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initModal();
      observeCartDrawer();
    });
  } else {
    initModal();
    observeCartDrawer();
  }
})();
